'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _immutable = require('immutable');

var map = function map() {
	var unmapped = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var propertyMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	var mapped = (0, _immutable.Map)(unmapped);

	Object.keys(propertyMap).forEach(function (oldKey) {
		if (mapped.has(oldKey)) {
			var newKey = propertyMap[oldKey];
			var value = mapped.get(oldKey);

			mapped = mapped.set(newKey, value);
			mapped = mapped.delete(oldKey);
		}
	});

	return mapped.toJS();
};

exports.default = map;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/common/PropertyHelper/map/index.js